import { render, staticRenderFns } from "./aRmsDayGeneralKpiColumns.vue?vue&type=template&id=542e0ed6&scoped=true"
import script from "./aRmsDayGeneralKpiColumns.vue?vue&type=script&lang=js"
export * from "./aRmsDayGeneralKpiColumns.vue?vue&type=script&lang=js"
import style0 from "./aRmsDayGeneralKpiColumns.vue?vue&type=style&index=0&id=542e0ed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542e0ed6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
